
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { IAPILocation } from '@hokify/common';

@Component({
	name: 'JobSearchPage',
	layout: 'plain-user',
	components: {
		Autocomplete: () => import('@hokify/shared-components/lib/components/Autocomplete.vue'),
		LocationAutocomplete: () =>
			import('@hokify/shared-components/lib/components/LocationAutocomplete.vue'),
		HokSelect: () => import('@hokify/shared-components/lib/components/HokSelect.vue')
	}
})
export default class JobSearchPage extends Vue {
	// Props for AutocompleteInner
	@Prop({ type: String, default: '' }) readonly currentJobField!: string;

	@Prop({ type: String, default: '' }) readonly currentLocationName!: string;

	@Prop({ type: String, default: '' }) readonly currentRadius!: string;

	@Prop({ type: Array }) readonly currentRadiusOptions!: { value: string }[];

	@Prop({ type: Boolean, default: false }) readonly autofocusBranch!: boolean;

	@Prop({
		type: [String, Boolean],
		default: false,
		validator: (value: string | boolean) => [false, 'mobile', 'always'].includes(value)
	})
	readonly fullwidth!: string | boolean;

	@Prop({ type: Function, required: true }) readonly valuePromise!: any;

	// Props for LocationAutocompleteInner
	@Prop({ type: Boolean, default: false }) readonly autofocusLocation!: boolean;

	@Prop({ type: Function }) readonly resolveGeoCoords!: (params: {
		long: number;
		lat: number;
	}) => Promise<IAPILocation>;

	@Prop({ type: Boolean }) readonly currentLocationButton!: boolean;

	locationName = this.currentLocationName;

	jobField = this.currentJobField;

	radius = this.currentRadius;

	focusedAc = false;

	focusedLac = false;

	radiusOptions = this.currentRadiusOptions;

	getRadiusOptions() {
		return this.radiusOptions;
	}

	mapSuggestionType(type: 'company' | 'keyword') {
		return type === 'company' ? 'Firma' : 'Job';
	}

	setRadius(event) {
		if (event.value === 'Zurücksetzen') {
			if (this.radiusOptions.length > 4) {
				this.radiusOptions.pop();
			}
			this.radius = '';
		} else {
			this.radius = event.value;
			if (this.radiusOptions.length < 5) {
				this.radiusOptions.push({ value: 'Zurücksetzen' });
			}
		}
	}

	updateJobField(
		searchTerm: string,
		_event,
		parameters?: { term: string; type: string; data?: { alias?: string } }
	) {
		if (parameters?.type === 'company' && parameters?.data?.alias) {
			this.$router.push({
				path: `/c/${parameters.data.alias}`
			});
		} else {
			this.jobField = searchTerm;
		}
	}

	setLocationName(locationPlaintext: string) {
		this.locationName = locationPlaintext;
		if (this.locationName.length === 0) {
			this.radius = '';
			if (this.radiusOptions.length > 4) {
				this.radiusOptions.shift();
			}
		}
	}
}
